import React, { useRef, useEffect, forwardRef, useState } from 'react';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment'
import DatePicker from 'react-datepicker'

import styled from 'styled-components/macro';

import "react-datepicker/dist/react-datepicker.css";

const onEscape = function (action) {
  window && window.addEventListener('keydown', (e) => {
    if (e.key === "Escape") {
      action();
    };
  });
};

let tabField = 0
const DateTime = (props) => {
 // console.log({props})
  const [value, setValue] = useState(props.value);
  const [date, setDate] = useState(props.value !== '(multiple values)' ? props.value : undefined);
  const [hour, setHour] = useState(props.value !== '(multiple values)' ? moment(props.value).format('HH') : null);
  const [mins, setMin] = useState(props.value !== '(multiple values)' ? moment(props.value).format('mm') : null);
  const [updating, setUpdating] = useState(false);
  let unBlurFlag = false
  const datePickerRef = useRef();

  const hourInputRef = useRef();
  const minInputRef = useRef();

  let canUpdate = true
  useEffect(() => {
    if (props.date) {
      // let mom = moment.props.value
    }
    try {
      if (tabField === 1) {
        hourInputRef.current.focus()
      } else if (tabField === 2) {
        minInputRef.current.focus()
      }
    } catch (error) {
      console.error({ error })
    }
  })

  const onMinsBlur = async () => {
    let newMin = mins
    if (newMin.length === 1) {
      newMin = "0" + newMin
    } else if (newMin.length > 2) {
      newMin = newMin.slice(-2)
    }
    if (newMin > 59) {
      await setMin(59)
    } else if (newMin < 0) {
      await setMin(0)
    } else if (newMin !== mins) {
      await setMin(newMin)
    }
    setTimeout(async () => {
      if (canUpdate) {
        let metadata = {
          [props.field]: moment(date).format('YYYY-MM-DD') + `T${hour}:${mins}:00`
        }
        let ids = []
        props.assets.forEach(o => {
          ids.push(o.id)
        })
        ids = ids.join(' OR ')
        await props.assetHelper.updateBulk(`id:(${ids})`, metadata)
        canUpdate = false
      } else {
        canUpdate = true
      }

    }, 200)
  }

  const onHoursBlur = async () => {
    let newHour = hour
    if (newHour.length === 1) {
      newHour = "0" + newHour
    } else if (newHour.length > 2) {
      newHour = newHour.slice(-2)
    }
    if (newHour > 23) {
      await setHour(23)
    } else if (newHour < 0) {
      await setHour(0)
    } else if (newHour !== hour) {
      await setHour(newHour)
    }
    setTimeout(async () => {
      if (canUpdate) {
        let metadata = {
          [props.field]: moment(date).format('YYYY-MM-DD') + `T${hour}:${mins}:00`
        }
        let ids = []
        props.assets.forEach(o => {
          ids.push(o.id)
        })
        ids = ids.join(' OR ')
        await props.assetHelper.updateBulk(`id:(${ids})`, metadata)
        canUpdate = false
      } else {
        canUpdate = true
      }

    }, 200)
  }

  const Container = styled.div`
    width: 100%;
    display: flex;
  `

  const DateField = styled.div`
    width: 100%;
    display: flex;
    min-height:17px;
    color: #000;
    flex:1;
    pointer-events: ${p => {
      if (p.disabled) {
        return 'none;'
      } else {
        return 'auto;'
      }
    }}
    border: 1px solid transparent;
    cursor: pointer;
    :hover {    
      border: 1px solid #d3d3d3;
    }
    :focus {    
      outline: 0;
      border: 1px solid #0095e0;
    }
  `
  const TimeField = styled.input`
    width: 100%;
    max-width: 32px;
    text-align:center;
    margin-left: 5px;  
    margin-right: 5px;    
    border: 1px solid transparent;
    :hover {    
      border: 1px solid #d3d3d3;
    }
    :focus {   
      outline: 0; 
      border: 1px solid #0095e0;
    }
  `

  const CancelButton = styled.div`
    display: flex;
    border: 1px solid #d3d3d3;
    border-radius: 8px;
    background: #d3d3d3;
    color: white;
    width: 13px;
    height: 13px;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    font-weight: bold;
    cursor: pointer;
    :hover {
      background: #0095e0;
      border: 1px solid #0095e0;
    }
  `

  const onKeyUpValue = (minHour, e1) => {
    // if ((e1.keyCode < 48 || e1.keyCode > 58) && (e1.keyCode !== 8 && e1.keyCode !== 46)) {
    //   // if (e1.key !== "0" || e1.key !== "1" || e1.key !== "2" || e1.key !== "3" || e1.key !== "4" || e1.key !== "5" || e1.key !== "6" || e1.key !== "7" || e1.key !== "8" || e1.key !== "9") {

    //   canAdd = false
    // } else {
    //   canAdd = true
    // }
  }

  const onDateChange = async (date) => {
    let hour1 = hour
    let mins1 = mins
    if (!hour || hour === 'Invalid date') {
      hour1 = '00'
      await setHour('00')
    }
    if (!mins || mins === 'Invalid date') {
      mins1 = '00'
      await setMin('00')
    }
    console.log({date})
    await setDate(date)
    let metadata = {
      [props.field]: moment(date).format('YYYY-MM-DDTHH:mm:ss') //+ `T${hour1}:${mins1}:00`
    }

    let ids = []
    props.assets.forEach(o => {
      ids.push(o.id)
    })
    ids = ids.join(' OR ')
    props.assetHelper.updateBulk(`id:(${ids})`, metadata)
  }



  const onHourChange = async (e) => {
    tabField = 1
    let val = e.target.value
    // if (val.length === 1) {
    //   val = "0" + val
    // }
    if (val > 23) {
      val = 23
    } else if (val < 0) {
      val = 0
    }

    await setHour(val)
  }

  const onMinChange = async (e) => {
    tabField = 2

    let val = e.target.value

    if (val > 59) {
      val = 59
    } else if (val < 0) {
      val = 0
    }
    await setMin(val)
  }

  const onDateClick = () => {
    // datePickerRef.current.setOpen(true);
  }


  const handleCalendarClose = () => {
  }

  const handleCalendarOpen = () => {
  }

  const onMinFocus = () => {
    tabField = 2
    canUpdate = true
  }

  const onHourFocus = () => {
    tabField = 1
    canUpdate = true

  }

  const onDelete = () => {
    let metadata = {
      [props.field]: ''
    }
    let ids = []
    props.assets.forEach(o => {
      ids.push(o.id)
    })
    ids = ids.join(' OR ')
    props.assetHelper.updateBulk(`id:(${ids})`, metadata)
  }

  let disabled = props.assets && props.assets.length === 0 ? true : !props.canEdit
  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <DateField disabled={disabled} ref={ref} onClick={onClick}>
      {(!date && props.canEdit) || date === '(multiple values)' ? ' ' : moment(date, 'x').format(props.format)}
    </DateField >
    // <button className="example-custom-input" onClick={onClick} ref={ref}>
    //   {value}
    // </button>
  ));

  let newHours = ''
  let newMins = ''
  let newDate = ''

  if (props.date && date !== '(multiple values)') {
    newHours = moment(props.date, 'x').format('HH')
    newMins = moment(props.date, 'x').format('mm')
    newDate = moment(props.date, 'x').format()


  }

  if (!props.date && date !== '(multiple values)') {
    newHours = hour
    newMins = mins
    //newDate = moment(props.date, 'x').format()
  }

  if (!date && props.canEdit) {
    let newDate = new Date()
    return <Container >
      <DatePicker
        ref={datePickerRef}
        selected={newDate}
        onChange={(date) => onDateChange(date)}
        customInput={<CustomInput />}
        showTimeSelect
        timeFormat="p"
        timeIntervals={1}
        onCalendarClose={handleCalendarClose}
        onCalendarOpen={handleCalendarOpen}
      />


      <div className="datecancelbuttoncontainer">
        <CancelButton>X</CancelButton>
      </div>
    </Container>

  } else if (date && props.canEdit) {
    return <Container >
      <DatePicker
        ref={datePickerRef}
        selected={date}
        onChange={(date) => onDateChange(date)}
        customInput={<CustomInput />}
        showTimeSelect
        timeFormat="p"
        timeIntervals={1}
        onCalendarClose={handleCalendarClose}
        onCalendarOpen={handleCalendarOpen}
      />


      <div className="datecancelbuttoncontainer">
        <CancelButton onClick={onDelete}>X</CancelButton>
      </div>
    </Container>

  } else if (!props.canEdit) {
    if (updating) {
      return <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #0095e0', color: 'black', textAlign: 'left', width: '100%'}}>
        {date && date !== '(multiple values)' ? moment(date, 'x').format(props.format) : ''}
      </div>
    } else {
      return <div style={{ display: 'flex', alignItems: 'center', color: 'black', textAlign: 'left', width: '100%' }}>
        {date && date !== '(multiple values)' ? moment(date, 'x').format(props.format) : ''}
      </div>
    }
  } else {
    return <div style={{ display: 'flex', alignItems: 'center' }}>

    </div>
  }



  //return Element;


  // return (
  //   <textarea rows={textRowCount} ref={inputRef} value={value} onChange={onChange.bind(this)} onKeyUp={onKeyUpValue.bind(this)} onBlur={onBlur.bind(this)} />
  // );
};

export default DateTime;